import { eEstadoDocumento, SolicitudSeccion } from "../common/enumModel";
import { IFilterConfiguracionDocumentoModel } from "../interfaces/configuracion-documento/IFilterConfiguracionDocumentoModel";

export class FilterConfiguracionDocumentoModel implements IFilterConfiguracionDocumentoModel {        
    id: number[];
    idEstado: eEstadoDocumento;
    idTipoVisita: number;
    idSeccion?: SolicitudSeccion;
    page: number;
    pageSize: number;

    constructor(){
        this.id = new Array<number>();
        this.idEstado = eEstadoDocumento.ACTIVO;
        this.idTipoVisita = 0;
        this.page = 1;
        this.pageSize = 30;
    }
}